import { Button, Typography } from "@mui/material";
import { AppRoutes } from "enums/routes.enum";
import { useTranslation } from "hooks";
import { useNavigate } from "react-router-dom";

export const ProfileButton = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleClick = () => navigate(AppRoutes.ACCOUNT);

    return (
        <Button
            variant="xs"
            sx={(theme) => ({
                width: "100%",
                textTransform: "capitalize",
                background: "none",
                border: `1px solid ${theme.palette.background.whiteOpacity4}`,
                minHeight: "40px",
            })}
            onClick={handleClick}
        >
            <Typography variant="body2Regular">{t("profile")}</Typography>
        </Button>
    );
};
